import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { SEOHead } from '../components/SEOHead';

export default function AppIndex() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    // Redirect to splash screen
    setLocation('/app/splash');
  }, [setLocation]);

  return (
    <div className="min-h-screen bg-[var(--color-white)] flex items-center justify-center">
      <SEOHead
        title="pixcapture.app"
        description="Professionelle Immobilienfotografie selbst erstellen"
        path="/app"
      />
      <div className="text-center">
        <p className="text-[var(--color-grey)]">Wird geladen...</p>
      </div>
    </div>
  );
}
